import { render, staticRenderFns } from "./template-content.vue?vue&type=template&id=08895935&scoped=true"
import script from "./template-content.vue?vue&type=script&lang=js"
export * from "./template-content.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08895935",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\WebBuild\\teamCity\\buildAgent\\work\\f0b2174a44415a20\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('08895935')) {
      api.createRecord('08895935', component.options)
    } else {
      api.reload('08895935', component.options)
    }
    module.hot.accept("./template-content.vue?vue&type=template&id=08895935&scoped=true", function () {
      api.rerender('08895935', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/template/template/components/template-content.vue"
export default component.exports